<template>

      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedDateFormatted"
            :label="label"
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            :required="ifRequired"
            :error-messages="errorMessage"
            @blur="handleBlur"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          scrollable
        >
        <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="handleDialogOkClick($refs.dialog)"
          >
            OK
        </v-btn>
        </v-date-picker>
      </v-dialog>
  
</template>

<script>

export default {

    props: [
        "label",
        "defaultValue",
        "error",
        "ifRequired",
        "errorMessage",
    ],

    data: function() {
      return({
        menu: false,
        date: this.defaultValue,
        modal: false
      });
    },

    computed: {
      computedDateFormatted: {
        get: function() {
          return this.formatDate(this.date)
        },
        set: function(val){
          //variable is change manually. Check the format
          var dateNewFormat = this.formatDate(val);
          if(!dateNewFormat || !this.checkDateFormat(dateNewFormat)){
             this.$emit('input', null)
          }else{
            this.$emit('input', dateNewFormat)
          }
        }
      }  
    },

    methods: {
      
      handleBlur (event) {
        this.$emit('blur', event)
      },

      formatDate (date) {
        if (!date) return null;
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      //Check date format with regex
      checkDateFormat (val){
            var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
            if (val.match(reg)) {
              return true;
            } else {
              return false;
            }          
      },

      handleDialogOkClick(ref){
        ref.save(this.date);
        this.$emit('input', this.date)
      }
    },


}
</script>

<style>

.red-class{
    color: red;
}

</style>